import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './Navbar.css';
import {
  AUTH_CHANGED_EVENT,
  clearAuthUser,
  getAuthUser,
  isAuthenticated
} from '../utils/userData';

const Navbar = () => {
  const navigate = useNavigate();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [authUser, setAuthUser] = useState(getAuthUser());

  useEffect(() => {
    const syncAuthState = () => setAuthUser(getAuthUser());

    window.addEventListener(AUTH_CHANGED_EVENT, syncAuthState);
    window.addEventListener('storage', syncAuthState);

    return () => {
      window.removeEventListener(AUTH_CHANGED_EVENT, syncAuthState);
      window.removeEventListener('storage', syncAuthState);
    };
  }, []);

  const handleLogout = () => {
    clearAuthUser();
    setIsMobileMenuOpen(false);
    navigate('/');
  };

  const firstName = authUser?.fullName?.split(' ')[0] || 'Member';

  return (
    <nav className="navbar">
      <div className="nav-content">
        <Link to="/" className="logo">Loungie</Link>
        
        <div className={`nav-menu ${isMobileMenuOpen ? 'active' : ''}`}>
          <Link to="/jobs" className="nav-link" onClick={() => setIsMobileMenuOpen(false)}>
            Opportunities
          </Link>
          <Link to="/about" className="nav-link" onClick={() => setIsMobileMenuOpen(false)}>
            About
          </Link>
          <Link to="/contact" className="nav-link" onClick={() => setIsMobileMenuOpen(false)}>
            Contact
          </Link>
          {isAuthenticated() ? (
            <>
              <Link to="/saved-jobs" className="nav-link" onClick={() => setIsMobileMenuOpen(false)}>
                Saved Jobs
              </Link>
              <span className="nav-user">Hi, {firstName}</span>
              <button className="btn-logout" onClick={handleLogout}>
                Logout
              </button>
            </>
          ) : (
            <>
              <Link to="/job-login" className="nav-link" onClick={() => setIsMobileMenuOpen(false)}>
                Login
              </Link>
              <Link to="/job-signup" className="btn-exclusive" onClick={() => setIsMobileMenuOpen(false)}>
                Join Now
              </Link>
            </>
          )}
        </div>

        <button 
          className="mobile-toggle"
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>
    </nav>
  );
};

export default Navbar;
